export const DAYS_OF_WEEK = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
]

export const WEEKEND_KEYS = ['saturday', 'sunday']
export const DEFAULT_WORKDAY_START = '09:00'
export const DEFAULT_WORKDAY_END = '17:00'

export const TIME_OPTIONS = (() => {
  const options = []
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
      const period = hour < 12 ? 'AM' : 'PM'
      const displayHour = hour % 12 === 0 ? 12 : hour % 12
      options.push({
        value,
        label: `${displayHour}:${String(minute).padStart(2, '0')} ${period}`,
      })
    }
  }
  return options
})()

export const createSlotId = () =>
  `slot-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`

export const buildDefaultAvailableTime = () =>
  DAYS_OF_WEEK.reduce((acc, day) => {
    acc[day.key] = WEEKEND_KEYS.includes(day.key)
      ? []
      : [{ id: createSlotId(), start: DEFAULT_WORKDAY_START, end: DEFAULT_WORKDAY_END }]
    return acc
  }, {})


// API sends times as "HH:MM:SS" ("09:45:00"), but the dropdown options are only "HH:MM" ("09:45"). If we don't strip the seconds, the value never matches any <option>, so the browser silently falls back to whichever option happens to be first, regardless of the real saved time.

export const stripSeconds = (time) => (time ? time.slice(0, 5) : '')

export const normalizeSlots = (rawSlots) => {
  if (!Array.isArray(rawSlots)) return null
  return rawSlots
    .filter((slot) => slot && (slot.start_time || slot.end_time))
    .map((slot) => ({
      id: createSlotId(),
      start: stripSeconds(slot.start_time),
      end: stripSeconds(slot.end_time),
    }))
}

// Per-day validation: every slot's own start/end must be in order, and
// slots within the same day must not overlap each other.
export const getSlotErrors = (slots = []) => {
  const errors = {}
  const sorted = [...slots].sort((a, b) =>
    (a.start || '').localeCompare(b.start || '')
  )

  sorted.forEach((slot, index) => {
    if (slot.start && slot.end && slot.start >= slot.end) {
      errors[slot.id] = 'End must be after start'
      return
    }
    const prev = sorted[index - 1]
    if (prev && !errors[prev.id] && slot.start && prev.end && slot.start < prev.end) {
      errors[slot.id] = 'Overlaps with another slot'
    }
  })

  return errors
}

export const formatLeaveDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(`${dateStr}T00:00:00`)
  if (Number.isNaN(date.getTime())) return dateStr
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

